module.exports = __webpack_public_path__ + "static/media/nhl-logo.e8c72f70.svg";